import {
  AddressingType,
  DenominationMode,
  EntrancePlantInfoCreateDTO,
  Language,
} from '@/../client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';
import {
  CallMode,
  addressBookSortingOptions,
} from '@/core/utils/EntrancePlant/entrance-plant.utils';
import { validLanguages } from '@/core/utils/utils';
import i18n from '@/core/translations/i18n';
import ToggleSwitchButton from '@/views/components/ToggleSwitchButton/ToggleSwitchButton.vue';
import HelpPopupButton from '@/views/components/HelpPopupButton/HelpPopupButton.vue';
import { PropType } from 'vue';

type SelectButtonValue = {
  label: string;
  value: DenominationMode;
};
@Options({
  name: 'CallModeForm',
  props: {
    infoPlant: {
      type: Object as PropType<EntrancePlantInfoCreateDTO>,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    sortingEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    adminView: {
      type: Boolean,
      default: false,
    },
  },
  components: { ToggleSwitchButton, HelpPopupButton },
  emits: ['update-list'],
})
export default class CallModeForm extends Vue {
  infoPlant: EntrancePlantInfoCreateDTO = new EntrancePlantInfoCreateDTO();
  adminView!: boolean;
  showHelpDialog = false;
  disabled!: boolean;
  sortingEnabled!: boolean;
  Language = Language;
  CallMode = CallMode;
  validLanguages = validLanguages;
  addressBookSortingOptions = addressBookSortingOptions;

  settingsList: SelectButtonValue[] = [
    {
      label: i18n.global.t('AppResourceEP.SetupBrfaNumbers'),
      value: DenominationMode.Numbers,
    },
    {
      label: i18n.global.t('AppResourceEP.SetupBrfaLetters'),
      value: DenominationMode.Letters,
    },
  ];

  get callMode() {
    switch (this.infoPlant.addressingType!) {
      case AddressingType.BuildingRiserFloorApartment:
        return CallMode.Brfa;

      case AddressingType.DirectCall_Alphanumeric:
      case AddressingType.DirectCall_NumbersOnly:
        return CallMode.DirectCall;

      case AddressingType.AddressBook:
        return CallMode.Address;
    }
  }

  set callMode(value: CallMode) {
    switch (value) {
      case CallMode.Address:
        this.infoPlant.addressingType = AddressingType.AddressBook;
        break;

      case CallMode.Brfa:
        this.infoPlant.addressingType =
          AddressingType.BuildingRiserFloorApartment;
        break;

      case CallMode.DirectCall:
        this.infoPlant.addressingType =
          this.infoPlant.addressingType ===
          AddressingType.DirectCall_Alphanumeric
            ? AddressingType.DirectCall_Alphanumeric
            : AddressingType.DirectCall_NumbersOnly;
        break;
    }
  }

  get callModeHelpDescription() {
    return this.$t('AppResourceEP.CallModeHelpDescription').split('\n');
  }

  get adminViewChosedOptionLabel() {
    switch (this.callMode) {
      case CallMode.Address:
        return this.$t('AppResourceEP.AddressBook');

      case CallMode.Brfa:
        return this.$t('AppResourceEP.BuildingRiserFloorApartment');

      case CallMode.DirectCall:
        return this.$t('AppResourceEP.CallWithCode');
    }
  }

  get adminViewChosedOptionDescription() {
    switch (this.callMode) {
      case CallMode.Address:
        return this.$t('AppResourceEP.AddressBookDescription');

      case CallMode.Brfa:
        return this.$t('AppResourceEP.BrfaDescription');

      case CallMode.DirectCall:
        return this.$t('AppResourceEP.CallWithCodeDescription');
    }
  }

  mounted(): void {}
}
